// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.highlight {
  padding: 0;
  background-color: var(--effects-highlight-active);
}`, "",{"version":3,"sources":["webpack://./js/vueComponents/selectionModal/src/selectionModal.vue","webpack://./selectionModal.vue"],"names":[],"mappings":"AACA;EACE,UAAA;EACA,iDAAA;ACAF","sourcesContent":["\nspan.highlight {\n  padding: 0;\n  background-color: var(--effects-highlight-active);\n}\n","span.highlight {\n  padding: 0;\n  background-color: var(--effects-highlight-active);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
